import { Code } from './../../core/model/dictionary';
export class Flag
{
    public id: number;
    public description: []; //string;
    public priority: Code;
    public flagType: Code;
    public category: Code;
    public memberId: number;
    public caseId: number;
    public privacy: string;
    public version: number;
}
